<app-header
  [title]="'SAVED REPORTS'"
  [details]="{ reportStatus: 'DRAFT' }"
  [showHomeButton]="true"
  [showTitle]="true">
</app-header>

<div class="reports-list" *ngIf="reports.length > 0; else noReports">
  <div *ngFor="let report of reports" class="report-card">
    <div class="d-flex align-items-center">
      <i class="bi bi-cloud-fill cloud-icon me-2"
         [ngClass]="{'online': report.isOnline, 'offline': !report.isOnline}"
         (click)="!report.isOnline && confirmToggleOnline(report.id)">
      </i>

      <div class="report-details flex-grow-1">
        <div class="report-address">{{ report.address }}</div>
        <div class="d-flex align-items-center">
          <div class="report-postcode">{{ report.postcode }}</div>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <span class="report-type">{{ report.type }}</span>
        <button class="btn btn-link text-danger" (click)="confirmDelete(report.id)">
          <i class="bi trash-icon"
             [ngClass]="{'bi-trash': !isHovered[report.id], 'bi-trash-fill': isHovered[report.id]}"
             (mouseenter)="isHovered[report.id] = true"
             (mouseleave)="isHovered[report.id] = false">
          </i>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #noReports>
  <div class="w-100 text-center">
    <img class="no-reports-image mt-3" src="/assets/no-reports.png">
    <div class="no-reports-message">No saved reports</div>
  </div>
</ng-template>

<!-- Modals -->
<div *ngIf="showModal" class="modal-backdrop">
  <div class="modal-content">
    <p>Are you sure you want to delete the local version of this report? This action is permanent and cannot be undone.</p>
    <button class="btn btn-primary mb-3" (click)="deleteReport()">Confirm</button>
    <button class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
  </div>
</div>

<div *ngIf="showCloudModal" class="modal-backdrop">
  <div class="modal-content">
    <p>Are you sure you want to change the online status of this report?</p>
    <button class="btn btn-primary mb-3" (click)="toggleOnlineStatus()">Confirm</button>
    <button class="btn btn-secondary" (click)="cancelToggleOnline()">Cancel</button>
  </div>
</div>